import Repository from "./Repository";

export default {
    getSurveyDetails(line_item_id) {
        return Repository.get(`/survey/${line_item_id}`);
    },
};
